// document.addEventListener('DOMContentLoaded', function () {
//     const header = document.querySelector('.header__grid');
//     const header_wrap = document.querySelector('.header')

//     const logo = document.querySelector('.img_header_logo');

//     if (!header) return;

//     const defaultLogo = logo ? logo.src : '';
//     const compactLogo = 'https://cdn.shopify.com/s/files/1/0644/2758/9747/files/logo-sticky.png?v=1783526796';

//     function updateHeader() {
//         const isCompact = window.scrollY > 0;

//         header.classList.toggle('compact', isCompact);
//         header_wrap.classList.toggle('header_compact', isCompact);

//         if (logo) {
//             // logo.src = isCompact ? compactLogo : defaultLogo;
//         }
//     }

//     updateHeader();

//     window.addEventListener('scroll', updateHeader);

//     header.addEventListener('mouseenter', function () {
//         header.classList.add('is-hovered');
//     });

//     header.addEventListener('mouseleave', function () {
//         header.classList.remove('is-hovered');
//     });
// });

document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.header__grid');
    const header_wrap = document.querySelector('.header');

    if (!header || !header_wrap) return;

    const isHome = document.body.classList.contains('home');

    if (!isHome) {
        header.classList.add('compact');
        // headerWrap.classList.add('header_compact');
        return;
    }

    let isHovered = false;

    function updateHeader() {
        const isScrolled = window.scrollY > 0;
        const isCompact = isScrolled || isHovered;

        header.classList.toggle('compact', isCompact);
        header_wrap.classList.toggle('header_compact', isCompact);
    }

    updateHeader();

    window.addEventListener('scroll', updateHeader);

    header.addEventListener('mouseenter', function () {
        isHovered = true;
        updateHeader();
    });

    header.addEventListener('mouseleave', function () {
        isHovered = false;
        updateHeader();
    });
});

document.addEventListener("DOMContentLoaded", function () {

    function initFooterAccordion() {

        if (window.innerWidth > 500) {
            document.querySelectorAll(".footer-column").forEach(function (column) {
                column.classList.remove("active");
            });
            return;
        }

        document.querySelectorAll(".footer-column-title").forEach(function (button) {

            if (button.dataset.bound) return;
            button.dataset.bound = "true";

            button.addEventListener("click", function () {
                this.parentElement.classList.toggle("active");
            });

        });

    }

    initFooterAccordion();

    window.addEventListener("resize", initFooterAccordion);

});

document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".category-tabs .tab");
    const contents = document.querySelectorAll(".living-content");

    contents.forEach(function (content, index) {
        if (index !== 0) {
            content.style.display = "none";
        }
    });

    tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () {
            tabs.forEach(function (item) {
                item.classList.remove("active");
            });

            contents.forEach(function (content) {
                content.style.display = "none";
            });

            tab.classList.add("active");
            contents[index].style.display = "grid";
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".space-tabs button");
    const banners = document.querySelectorAll(".space-banner");

    banners.forEach(function (banner, index) {
        if (index !== 0) {
            banner.style.display = "none";
        }
    });

    tabs.forEach(function (tab, index) {
        tab.addEventListener("click", function () {
            tabs.forEach(function (item) {
                item.classList.remove("active");
            });

            banners.forEach(function (banner) {
                banner.style.display = "none";
            });

            tab.classList.add("active");
            banners[index].style.display = "block";
        });
    });
});

  document.addEventListener('DOMContentLoaded', function () {
      new Swiper('.recommendations-sliderx', {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 16,
          speed: 500,
          grabCursor: true,
          loop: false,

          breakpoints: {
              768: {
                  slidesPerView: 4,
                  slidesPerGroup: 1,
                  spaceBetween: 24
              }
          },

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

        //   pagination: {
        //       el: '.swiper-pagination',
        //       clickable: true,
        //   },
      });
  });